import { Dialog } from "@headlessui/react";
import { FormBox, ModalFoterBox } from "../../components/box/Box";
import Button from "../../components/button/Button";
import { Modal, ModalProp } from "../../components/modal/Modal";
import { Controller, useForm } from "react-hook-form";
import { VideoContents, videoContentsSchema } from "../../model/VideoContents";
import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect } from "react";
import FormController from "../../components/fields/FormController";
import { TextField } from "../../components/fields/Fields";
import { RadioButton } from "../../components/radiobutton/RadioButton";
import { useInput } from "../../hooks/useInput";
import TableList, { GridCol, GridRow } from "../../components/table/TableList";

export type VideoContentsAddModalProp = {
  onContentsAddSubmit: (data: VideoContents) => Promise<void>;
  data?: VideoContents;
  isLoad: boolean;
  selectToggle: () => void;
  selectColumn: GridCol[];
  selectRows: GridRow[];
}

export const VideoContentsAddModal = ({
  open,
  toggle,
  closeOnClickOutside,
  onContentsAddSubmit: onContentsAdd,
  data,
  isLoad,
  selectToggle,
  selectColumn,
  selectRows
}: ModalProp & VideoContentsAddModalProp) => {
  const { control, handleSubmit, setValue, reset } =
    useForm<VideoContents>({
      resolver: yupResolver(videoContentsSchema),
      defaultValues: data
    });

  const selectTypeItems = [
    {id: "youtube", title: "YouTube", value: "YouTube"},
    {id: "url", title: "URL", value: "URL"}
  ];
  const selectType = useInput('YouTube');

  useEffect(() => {
    setValue('id', data?.id ?? '');
    setValue('title', data?.title ?? '');
    setValue('url', data?.url ?? '');
    setValue('categoryIdOrderMaps', data?.categoryIdOrderMaps ?? {});
    setValue('explanation', data?.explanation ?? '');
    selectType.setValue(data?.type ?? 'YouTube');
    setValue('type', selectType.value);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[data?.id, data?.explanation, data?.title, data?.type, data?.url, open,
    data?.categoryIdOrderMaps, setValue]);

  useEffect(() => {
    setValue('type', selectType.value);
  },[selectType.value, setValue])

  useEffect(() => {
    if(!open) {
      reset();
      selectType.setValue(data?.type);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[data?.type, open, reset]);

  return (
    <>
      <Modal
        open={open}
        toggle={toggle}
        closeOnClickOutside={closeOnClickOutside}
      >
        <Dialog.Panel className=" relative transform overflow-hidden rounded-lg bg-white  text-left shadow-xl transition-all sm:w-full max-w-screen-md ">
          <div className="text-center sm:mt-3">
            <Dialog.Title
              as="h3"
              className="text-left p-4 text-lg font-medium leading-6 text-gray-900"
            >
              動画コンテンツ登録
            </Dialog.Title>
            <div className="overflow-y-auto">
              <div className="text-left h-[calc(100vh_-_16rem)] p-4 ">
                <FormBox gridcol={"grid-cols-2"} className={"sm:pt-[0px]"}>
                  <FormBox gridcol={"grid-cols-1"} className={"sm:pt-[0px]"}>
                    <FormController
                      control={control}
                      name={"title"}
                      label={"タイトル"}
                      type={"text"}
                      required
                    />
                    <RadioButton
                      control={control}
                      children={undefined}
                      name={"type"}
                      label={"動画タイプ"}
                      value={selectType}
                      radioButtonItem={selectTypeItems}
                      className={"pb-4"}
                      vertical
                    />
                    <FormController
                      control={control}
                      name={"url"}
                      label={"コンテンツのURL"}
                      type={"text"}
                      required
                    />
                    <Button
                      children={"登録先団体選択"}
                      onClick={selectToggle}
                    />
                  </FormBox>
                  <Controller
                    name="explanation"
                    control={control}
                    render={({ field, fieldState }) => (
                      <TextField
                        {...field}
                        type="textarea"
                        label="説明文"
                        className="h-80 pb-10"
                        error={fieldState.error}
                        helperText={fieldState.error?.message}
                      />
                    )}
                  />
                </FormBox>
                {selectRows.length > 0 && (
                  <TableList
                    header
                    footer={false}
                    limit={4}
                    gridCol={selectColumn}
                    gridRow={selectRows}
                  />)
                }
              </div>
            </div>
          </div>
          <ModalFoterBox>
            <Button
              className="mx-2 mt-1 w-[132px]"
              outline
              onClick={toggle}
              children={"キャンセル"}
            />
            <Button
              className="mt-1 mr-2 w-[132px]"
              children={'登録'}
              onClick={handleSubmit(onContentsAdd)}
              disabled={isLoad}
            />
          </ModalFoterBox>
        </Dialog.Panel>
      </Modal>
    </>
  )
}